export const account = {
  seo: {
    login: {
      title: 'ログイン | LensBank',
      description: 'LensBank会員センターにログインし、注文状況の確認、個人情報の管理、機材レンタルの予約ができます。'
    },
    register: {
      title: '会員登録 | LensBank',
      description: 'LensBank会員登録で、便利な機材予約サービスと特典をお楽しみください。'
    },
    profile: {
      title: '個人情報 | LensBank マイページ',
      description: '個人情報、連絡先、設定を管理します。'
    },
    orders: {
      title: 'マイ注文 | LensBank マイページ',
      description: '機材レンタル注文の状況と履歴を確認します。'
    },
    forgotPassword: {
      title: 'パスワードを忘れた | LensBank',
      description: 'LensBank アカウントのパスワードをリセットします。'
    }
  },
  login: {
    title: 'ログイン',
    email: 'メールアドレス',
    password: 'パスワード',
    rememberMe: 'ログイン状態を保持',
    forgotPassword: 'パスワードをお忘れですか？',
    loginButton: 'ログイン',
    loggingIn: 'ログイン中...',
    noAccount: 'アカウントをお持ちでないですか？',
    register: '今すぐ登録',
    emailPlaceholder: 'メールアドレスを入力',
    passwordPlaceholder: 'パスワードを入力'
  },
  register: {
    title: '会員登録',
    name: '氏名',
    email: 'メールアドレス',
    phone: '電話番号',
    password: 'パスワード',
    confirmPassword: 'パスワード確認',
    company: '会社名（任意）',
    vatNumber: '法人番号（任意）',
    registerButton: '登録',
    registering: '登録中...',
    hasAccount: 'すでにアカウントをお持ちですか？',
    login: '今すぐログイン',
    agree: '同意します',
    terms: '利用規約',
    and: 'と',
    privacy: 'プライバシーポリシー',
    success: {
      title: '登録成功！',
      message: '確認メールを送信しました',
      checkEmail: 'メールボックスを確認し、確認リンクをクリックしてアカウントを有効にしてください',
      backToLogin: 'ログインページに戻る'
    }
  },
  forgotPassword: {
    title: 'パスワードを忘れた',
    description: 'メールアドレスを入力してください。パスワードリセットのリンクをお送りします',
    email: 'メールアドレス',
    emailPlaceholder: 'メールアドレスを入力',
    sendButton: 'リセットリンクを送信',
    sending: '送信中...',
    backToLogin: 'ログインに戻る',
    success: {
      title: 'リセットリクエストを送信しました！',
      message: 'このメールアドレスが登録されている場合、パスワードリセットのリンクを送信します。受信トレイと迷惑メールフォルダをご確認ください。',
      checkEmail: 'リンクの有効期限は1時間です。お早めに操作してください。',
      backToLogin: 'ログインページに戻る'
    }
  },
  resetPassword: {
    title: 'パスワードをリセット',
    description: '新しいパスワードを入力し、確認してください',
    newPassword: '新しいパスワード',
    confirmPassword: '新しいパスワード確認',
    submitButton: 'パスワードをリセット',
    submitting: 'リセット中...',
    successTitle: 'パスワードをリセットしました！',
    successMessage: 'パスワードが更新されました。新しいパスワードでログインしてください。',
    backToLogin: 'ログインページに戻る',
    invalidOrExpired: 'リセットリンクが無効または期限切れです。再度パスワードリセットを申請してください。',
    errorTitle: 'パスワードをリセットできません',
    errorMessage: '確認リンクが無効または期限切れです。'
  },
  errors: {
    invalidEmail: '有効なメールアドレス形式を入力してください',
    emailRequired: 'メールアドレスを入力してください',
    passwordRequired: 'パスワードを入力してください',
    passwordTooShort: 'パスワードは8文字以上必要です',
    passwordMismatch: 'パスワードが一致しません',
    nameRequired: '氏名を入力してください',
    phoneRequired: '電話番号を入力してください',
    invalidCredentials: 'メールアドレスまたはパスワードが間違っています',
    emailAlreadyExists: 'このメールアドレスは既に登録されています',
    userNotFound: 'このアカウントが見つかりません',
    networkError: 'ネットワーク接続エラー。後でもう一度お試しください',
    unknownError: '不明なエラーが発生しました。後でもう一度お試しください',
    agreeTerms: '利用規約とプライバシーポリシーに同意してください'
  },
  profile: {
    title: '個人情報',
    subtitle: '個人情報とアカウント設定を管理',
    basicInfo: '基本情報',
    name: '氏名',
    email: 'メールアドレス',
    emailReadonly: 'メールアドレスは変更できません',
    phone: '電話番号',
    company: '会社名',
    vatNumber: '法人番号',
    preferredLocation: 'よく利用する店舗',
    selectLocation: '店舗を選択',
    changePassword: 'パスワード変更',
    currentPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    confirmPassword: '新しいパスワード確認',
    save: '変更を保存',
    saving: '保存中...',
    cancel: 'キャンセル',
    edit: '情報を編集',
    security: 'アカウントセキュリティ',
    password: 'パスワード',
    change: '変更',
    changePasswordNote: 'パスワードを変更するには、「パスワードを忘れた」ページでリセットしてください',
    updateSuccess: '個人情報が正常に更新されました',
    updateError: '更新に失敗しました。後でもう一度お試しください',
    adminAccountNotice: 'このアカウントは最高権限管理アカウントです。セキュリティ上の理由から、フロントでのレンタルアカウントとして使用できません。一般顧客アカウントを使用してテストまたは注文してください。',
    staffAccountNotice: '現在、LensBank 社員アカウントとしてログインしています。フロントでのレンタル機能を使用するには、まず個人レンタル情報を作成してください。この情報はフロントレンタル専用であり、バックエンドの権限には影響しません。',
    staffAccountReady: '現在、LensBank 社員アカウントとしてログインしています。フロントレンタル情報が作成済みです。フロントレンタル機能を正常に使用でき、バックエンドの権限には影響しません。',
    createRentalProfile: '編集してフロントレンタル情報を作成'
  },
  orders: {
    title: 'マイ注文',
    subtitle: 'レンタル注文の状況と履歴を確認',
    allOrders: 'すべての注文',
    pending: '審査待ち',
    approved: '確認済み',
    completed: '完了',
    orderNumber: '注文番号',
    date: '注文日',
    status: 'ステータス',
    total: '合計金額',
    action: '操作',
    viewDetails: '詳細を見る',
    noOrders: '現在注文はありません',
    startBrowsing: '機材を見る',
    statuses: {
      draft: '下書き',
      pending: '審査待ち',
      need_info: '情報補足必要',
      approved: '確認済み',
      rejected: '拒否',
      completed: '完了',
      cancelled: 'キャンセル'
    },
    statusPending: '審査待ち',
    statusApproved: '確認済み',
    statusNeedInfo: '情報補足必要',
    statusCompleted: '完了',
    statusCancelled: 'キャンセル',
    detail: {
      title: '注文詳細',
      orderInfo: '注文情報',
      orderNumber: '注文番号',
      orderDate: '注文日',
      status: 'ステータス',
      rentalPeriod: 'レンタル期間',
      pickupLocation: '受取店舗',
      items: '注文項目',
      equipment: '機材',
      equipmentList: '機材リスト',
      quantity: '数量',
      days: '日',
      price: '金額',
      subtotal: '小計',
      total: '合計',
      totalPrice: '合計金額',
      notes: '備考',
      customerNotes: 'お客様備考',
      adminNotes: '管理者メモ',
      cancel: '注文をキャンセル',
      back: 'リストに戻る',
      backToOrders: '注文リストに戻る',
      orderDetails: '注文詳細'
    }
  },
  nav: {
    profile: '個人情報',
    orders: 'マイ注文',
    cart: '予約カート',
    logout: 'ログアウト'
  },

  // 新增：購物車相關翻譯
  cart: {
    title: '予約カート',
    subtitle: '機材予約リストを確認',
    empty: '予約カートは空です',
    emptyDescription: '機材を閲覧してカートに追加',
    startBrowsing: '機材を見る',
    days: '日',
    quantity: '数量',
    remove: '削除',
    removeConfirm: 'この項目を削除してもよろしいですか？',
    removeSuccess: 'カートから削除しました',
    summary: '注文概要',
    subtotal: 'レンタル料金',
    deposit: '保証金',
    total: '合計',
    depositNote: '保証金は機材返却後に返金されます',
    proceedToCheckout: 'チェックアウトへ',
    continueBooking: '予約を続ける',
    loginRequired: 'チェックアウトするにはログインが必要です'
  },

  // ✅ 新增：結帳相關翻譯
  checkout: {
    title: 'チェックアウト',
    subtitle: 'レンタル情報を入力して予約を完了',
    loginRequired: 'チェックアウトするには会員ログインが必要です',
    rentalInfo: 'レンタル情報',
    startDate: '受取日',
    endDate: '返却日',
    pickupLocation: '受取店舗',
    selectLocation: '受取店舗を選択',
    rentalDays: '日数',
    days: '日',
    equipmentList: '機材リスト',
    quantity: '数量',
    projectInfo: '撮影情報',
    projectType: 'プロジェクトタイプ',
    projectTypePlaceholder: '例：商業撮影、ウェディング記録、動画撮影など',
    shootingLocation: '撮影場所',
    shootingLocationPlaceholder: '例：台北市信義区、屋外撮影など',
    specialRequirements: '特別なご要望',
    specialRequirementsPlaceholder: '特別なご要望や注意事項をお知らせください',
    orderSummary: '注文概要',
    equipmentSubtotal: '単価合計',
    subtotal: '小計',
    discount: '割引',
    rentalTotal: 'レンタル合計',
    deposit: '保証金',
    total: '合計',
    depositNote: '保証金は機材返却後に返金されます',
    submitOrder: '注文を確定',
    submitting: '送信中...',
    backToCart: 'カートに戻る',
    agreeTerms: '同意します',
    rentalTerms: 'レンタル規約',
    fillRequired: 'すべての必須項目を入力してください',
    agreeTermsRequired: 'レンタル規約に同意してください',
    success: {
      title: '予約完了！',
      message: 'ご予約ありがとうございます',
      description: 'ご予約内容を確認し、できるだけ早くご連絡いたします',
      orderNumber: '注文番号',
      viewOrders: '注文を確認',
      backToHome: 'ホームに戻る'
    },
    successModal: {
      title: '注文が送信されました',
      message: '注文は送信されましたが、確定ではありません。\n受取店舗が在庫確認を完了した後、LINE または Email でご連絡いたします。\n「マイ注文」で最新状況を確認できます。',
      viewOrdersButton: 'マイ注文を確認',
      continueBrowsingButton: '機材を見る'
    },
    adminAccountBlocked: 'このアカウントは最高権限管理アカウントです。セキュリティ上の理由から、フロントでのレンタルアカウントとして注文できません。一般顧客アカウントを使用してください。',
    staffNeedProfile: 'フロントレンタル情報を先に作成してから、注文を送信してください。'
  },
  
  // Email 確認相關
  confirmingEmail: 'メールアドレスを確認中...',
  pleaseWait: 'お待ちください',
  confirmSuccess: '確認成功！',
  emailConfirmed: 'メールアドレスが正常に確認されました。ようこそ！',
  confirmFailed: '確認失敗',
  emailConfirmError: '確認リンクが無効または期限切れです。再度登録してください',
  redirectingToHome: 'ホームページにリダイレクトしています...',
  backToLogin: 'ログインページに戻る',
};